import { useTranslation } from 'react-i18next';
import { ChannelStatus } from 'services/api/youtubeChannel/types';
import {
  StyledErrorIcon,
  StyledErrorTypography,
  StyledPendingIcon,
  StyledPendingTypography,
  StyledStatusMessage,
  StyledSuccessIcon,
  StyledSuccessTypography,
} from './styled';

type PropsType = {
  status?: string;
  error?: string;
};
const StatusMessage = ({ error, status }: PropsType) => {
  const { t } = useTranslation();

  return (
    <>
      {(error || status === ChannelStatus.DECLINED) && (
        <StyledStatusMessage>
          <StyledErrorIcon />
          <StyledErrorTypography>
            {error ||
              t(
                'account:youtubeChannel:whitelistContainer:statusMessage:declined'
              )}
          </StyledErrorTypography>
        </StyledStatusMessage>
      )}
      {status === ChannelStatus.PENDING && (
        <StyledStatusMessage>
          <StyledPendingIcon />
          <StyledPendingTypography>
            {t(
              'account:youtubeChannel:whitelistContainer:statusMessage:pending'
            )}
          </StyledPendingTypography>
        </StyledStatusMessage>
      )}
      {status === ChannelStatus.ACCEPTED && (
        <StyledStatusMessage>
          <StyledSuccessIcon />
          <StyledSuccessTypography>
            {t(
              'account:youtubeChannel:whitelistContainer:statusMessage:accepted'
            )}
          </StyledSuccessTypography>
        </StyledStatusMessage>
      )}
    </>
  );
};

export default StatusMessage;
